//mutations
export const RESET_DOCUMENT_STATE = 'RESET_DOCUMENT_STATE';
export const SET_RECENT_DOCUMENTS = 'SET_RECENT_DOCUMENTS';
export const SET_RECENT_DOCUMENT_COUNT = 'SET_RECENT_DOCUMENT_COUNT';
export const SET_SHARED_DOCUMENT_FILES = 'SET_SHARED_DOCUMENT_FILES';
export const SET_FILE_LIST_MAX_PAGE = 'SET_FILE_LIST_MAX_PAGE';
export const SET_FOLDER_FILES_TOTAL = 'SET_FOLDER_FILES_TOTAL';
export const UPDATE_SYNCFUSION_STATE = 'UPDATE_SYNCFUSION_STATE';

//actions
export const SET_DOCUMENT_LOCK = 'SET_DOCUMENT_LOCK';
export const CLEAR_DOCUMENT_LOCK = 'CLEAR_DOCUMENT_LOCK';
export const GET_DOCUMENT_FOLDERS = 'GET_DOCUMENT_FOLDERS';
export const GET_RECENT_DOCUMENTS = 'GET_RECENT_DOCUMENTS';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const SET_DOCUMENT_ACTIVITY = 'SET_DOCUMENT_ACTIVITY';
export const UPDATE_DOCUMENT_FILE = 'UPDATE_DOCUMENT_FILE';
export const GET_SHARED_DOCUMENT_FILES = 'GET_SHARED_DOCUMENT_FILES';
export const SET_ACTIVE_DOCUMENT = 'SET_ACTIVE_DOCUMENT';
export const GET_DOCUMENT_DATA = 'GET_DOCUMENT_DATA';
export const LOCK_DOCUMENT = 'LOCK_DOCUMENT';
export const UNLOCK_DOCUMENT = 'UNLOCK_DOCUMENT';
export const GET_SYNCFUSION_ASSETS = 'GET_SYNCFUSION_ASSETS';
